module.exports = __webpack_public_path__ + "img/qrcode2.c06b09f3.png";